export const validationAttributes = {
  name_bng: "Applicant's Name (in Bangla)",
  religion: 'Religion',
  nid_brno: 'NID or Birth-Registration Number',
  blood_group: 'Blood Group',
  nationality: 'Nationality',
  interested_bncc: 'Interested in BNCC',
  is_married: 'Marital Status',
  spouse_name: "Spouse's Name",
  spouse_mobile: "Spouse's Mobile Number",
  spouse_address: "Spouse's Contact Address",
  guardian_income_number: "Guardian's Monthly Income (in numbers)",
  guardian_income_word: "Guardian's Monthly Income (in words)",

  residence_address: 'Residence Address',
  residence_mobile: 'Residence Contact Number',
  self_residence: 'Self Residence Status',
  

  present_house: 'Present Address - House / Holding No.',
  present_village: 'Present Address - Village / Ward / Road',
  present_poffice: 'Present Address - Post Office',
  present_thana: 'Present Address - Thana/Upozilla',
  present_district: 'Present Address - District',
  present_mobile: 'Present Address - Contact Number',

  both_address_same: 'Are Present and Permanent Address Same?',

  permanent_house: 'Permanent Address - House / Holding No.',
  permanent_village: 'Permanent Address - Village / Ward / Road',
  permanent_poffice: 'Permanent Address - Post Office',
  permanent_thana: 'Permanent Address - Thana/Upozilla',
  permanent_district: 'Permanent Address - District',
  permanent_mobile: 'Permanent Address - Contact Number',

  fname_bng: "Father's Name (in Bangla)",
  foccupation: "Father's Occupation",
  fdesignation: "Father's Job Designation",
  femployer_info: "Father's Employer Information",
  fnid_brno: "Father's NID or Birth-Registration Number",
  mname_bng: "Mother's Name (in Bangla)",
  fmobile: "Father's Mobile Number",
  mnid_brno: "Mother's NID or Birth-Registration Number",
  mmobile: "Mother's Mobile Number",
  guardian_name: "Local Guardian's Name",
  guardian_relation: "Local Guardian's Relation",
  guardian_nid_brno: "Local Guardian's NID or Birth-Registration Number",
  guardian_mobile: "Local Guardian's Mobile Number",
  guardian_address: "Local Guardian's Contact Address",

  ssc_institute: 'Name of the School (SSC Level)',
  ssc_center: 'Exam Center Code (SSC Level)',
  hsc_institute: 'Name of the College (HSC Level)',
  hsc_center: 'Exam Center Code (HSC Level)', 

  is_employee: 'is Employee',
  job_description: 'Job Description',
  employer_details: 'Employer Details',
  employer_address: 'Employer Address',

  is_admitted: 'is Admitted',
  admitted_course: 'Admitted Course',
  admitted_session: 'Admitted Session',
  admitted_subject: 'Admitted Subject',
  admitted_institute: 'Admitted Institute',
  admitted_regino: 'Admitted Region',
  admitted_classroll: 'Admitted Class Roll',

  is_postponed: 'is Postponed',
  postponed_reason: 'Postponed Reason',
  is_expeled: 'is Expeled',
  expeled_reason: 'Expeled Reason',
  expeled_period: 'Expeled Period',
  expeled_institute: 'Expeled Institute',
  expeled_examinfo: 'Expeled Exam Inforamation',
  is_readmitted: 'is Readmitted',
  readmission_reason: 'Readmission Reason',


}
